import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

import { useMainStore } from "@/stores/main";
import Election from "@/components/election/Election.vue";
import { onMounted, ref } from "vue";
import { ratio, a4ratio } from "./../../components/map/map/settings";

const padding = 20;


export default /*@__PURE__*/_defineComponent({
  __name: 'Main',
  setup(__props) {

const store = useMainStore();

const content = ref<HTMLElement | null>(null);

onMounted(() => {
    if (content.value) {
        const buffer = 4;
        const width = content.value.clientWidth - buffer;
        const height = content.value.clientHeight - buffer;
        const realRatio = width / height;
        if (realRatio > ratio) {
            store.width = Math.min(height / a4ratio, 500);
        } else {
            store.width = Math.min(width, 500);
        }
        store.measured = true;
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "Main",
    style: _normalizeStyle({ padding: padding + 'px' })
  }, [
    _createElementVNode("div", {
      class: "Main__content",
      ref_key: "content",
      ref: content
    }, [
      (_unref(store).init)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(store).elections, (election) => {
            return (_openBlock(), _createBlock(Election, {
              key: election.id,
              election: election
            }, null, 8, ["election"]))
          }), 128))
        : _createCommentVNode("", true)
    ], 512)
  ], 4))
}
}

})